import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useKeycloak } from '@eggplant/context'
import type {
  Error,
  SmtpSettings
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: () => ReactElement
  onSuccess?: (value: SmtpSettings) => void
  onError?: (error: Error) => void
  params?: SmtpSettings
}

const GetSmtpRequest = ({
  children,
  onSuccess,
  onError,
  params
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()
  const url = `${keycloakInstance.authServerUrl}/realms/${keycloakInstance.realm}/dai/v1//smtp`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetSmtpRequest
